import { render, staticRenderFns } from "./WholeCalendarDayEventsDialog.vue?vue&type=template&id=f7d4f464"
import script from "./WholeCalendarDayEventsDialog.vue?vue&type=script&lang=js"
export * from "./WholeCalendarDayEventsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports